export default __webpack_public_path__ + "static/media/plug.392c8dae.png";